import jQuery from "jquery";

export default function(triggerEl) {
	let trigger = jQuery(triggerEl);

	trigger.click(function (e) {
		e.preventDefault();

		const trigger = this;
		const link = jQuery(this);
		const target = link.attr('href');
		const group = link.data('toggle-group');

		jQuery('*[data-toggle-group="'+group+'"]').each(function () {
			if(this === trigger) {
				return;
			}
			const target = jQuery(this).attr('href');
			jQuery(target).fadeOut(150);
		});

		let targetElem = jQuery(target);
		if(targetElem.is(':visible')) {
			$(trigger).toggleClass('closed open');
			targetElem.fadeOut(150);
		} else {
			$(trigger).toggleClass('closed open');
			targetElem.fadeIn(150);
		}

		targetElem.find('.close').click(function(e) {
			e.preventDefault();
			targetElem.fadeOut(150);
		});
	});

	if(!trigger.hasClass('open')) {
		trigger.addClass('closed');
		jQuery(trigger.attr('href')).hide();
	}
}
